import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  styled,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
  IconButton,
  Grid,
  Box,
  Typography,
  Paper,
  useMediaQuery,
  AppBar,
  Toolbar,
  Button as MuiButton,
} from "@mui/material";
import img1 from "../../assets/images/sba_banner_new.jpg";
// import img1 from "../../assets/images/Login Screen.svg";
// import logo1 from "../../assets/vendor/Group 27363.svg";
import logo1 from "../../assets/images/SakshamLogo.svg";
import img4 from "../../assets/vendor/img1.png";
import img5 from "../../assets/vendor/img2.png";
import img6 from "../../assets/vendor/Illustration 2.png";
import "./Logincss.css";
import validator from "validator";
// Custom Components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Utilities
import { AGENT } from "utils/constant";
import { ADMIN } from "utils/constant";
import { spacing } from "@mui/system";
import Swal from "sweetalert2";

// Images
// import image from "../../assets/images/landing_img.png";
import image from "assets/sba_images/png/home_screen.png";
import logo from "../../assets/sba_images/png/SamarthaLogo.png";
import pageRoutes from "page.routes";
import Card from "@mui/material/Card";
import axios from "axios";
import { outlinedInputClasses } from "@mui/material";
import link from "assets/theme/components/link";
import Button from "@girishsawant999/react-loading-button";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import imgMain from "../../assets/images/image 154.png";
import imgA from "../../assets/images/Group 27479 (1).png";
import imgA1 from "../../assets/images/mysba logo 1.png";
import imgA2 from "../../assets/images/mysba logo 1 (1).png";
import imgA3 from "../../assets/images/mysbalogonew.png";

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "rgba(255, 174, 94, 1)",
            borderRadius: "8px",
          },
          root: {
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "rgba(255, 174, 94, 1)",
            },
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "rgba(255, 174, 94, 1)",
            },
          },
        },
      },
    },
  });

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  background: "white",
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontSize: "12px",
}));

const LoginVendor = () => {
  const matchsm = useMediaQuery("(max-width:768.5px)");
  const navigate = useNavigate();
  const outerTheme = useTheme();
  const transparent = false;
  const light = false;
  const [userRole, setUserRole] = useState(AGENT);
  const [OTP, setOTP] = useState({
    mobileno: "",
    otp: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [counter, setCounter] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [loginEmail, setLoginEmail] = useState({
    email: "",
    password: "",
  });

  const [otpbutton, Setotpbuton] = useState(false);
  const [otpinput, Setotpinput] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const sendOtp = () => {
    // Setotpinput(true);
    Setotpbuton(true);

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL_AUTH}/login/sendotp`, {
        mobnum: OTP.mobileno,
        partner_association: "Samarth",
      })
      .then((res) => {
        Setotpinput(true);
        Setotpbuton(true);
        Swal.fire({
          position: "top",
          icon: "sucess",
          title: `${res.response.data["User Message"]}`,
          // text: res.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      })
      .catch((err) => {
        Setotpbuton(false);
        // Setotpinput(false);
        Swal.fire({
          position: "top",
          icon: "warning",
          // title: `${err.response.data["User Message"]}`,
          title: "Oops...",
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  const changeUser = (e, type) => {
    // double clicking on same option deselects and sets type as null
    if (type !== null) {
      setUserRole(type);
    }
  };

  const CapitalizeFunc = (name) => {
    const arr = name.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    console.log("Login access:", str2);
    return str2;
  };

  const handleLogin = async () => {
    if (userRole === "admin") {
      setIsLoading(true);
      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/login/phone`, {
          mobile_number: OTP.mobileno,
          otp: OTP.otp,
          // partner_association: "Samarth",
        })
        .then((res) => {
          console.log(res.data, "res1");
          if (res.status === 200) {
            sessionStorage.setItem("register_id", res.data["Registration ID"]);
            sessionStorage.setItem("token", res.data.Token.refresh);
            sessionStorage.setItem("user_name", res.data.Name);
            sessionStorage.setItem("cp_type", res.data.type);
            // navigate("/superadmin/dashboard");
            res.data.type === "Skilling Partner"
              ? navigate("/courses-assigned")
              : navigate("/dashboard");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          Swal.fire({
            position: "top",
            icon: "warning",
            title: `${err.response.data["Developer Message"]}`,
            showConfirmButton: false,
            timer: 3000,
          });
          setIsLoading(false);
        });
    } else {
      if (!validator.isEmail(loginEmail.email)) {
        Swal.fire({
          icon: "error",
          title: "Enter a valid email!",
          showConfirmButton: false,
          timer: 2000,
        });
      } else if (loginEmail.password === "") {
        Swal.fire({
          icon: "error",
          title: "Enter a password!",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        setIsLoading(true);
        await axios
          .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/account/email/login`, {
            email: loginEmail.email,
            password: loginEmail.password,
            // partner_association: "Samarth",
          })
          .then((res) => {
            if (res.status === 200) {
              sessionStorage.setItem("email", loginEmail.email);
              sessionStorage.setItem("register_id", res.data["Registration ID"]);
              sessionStorage.setItem("creator_role", res.data["Creator_Role"]);
              sessionStorage.setItem("token", res.data["Token"].access);
              sessionStorage.setItem("user_name", res.data.Name);
              sessionStorage.setItem("cp_type", res.data.type);
              // navigate("/superadmin/dashboard");
              res.data.type === "Skilling Partner"
                ? navigate("/courses-assigned")
                : navigate("/dashboard");
            }
            setIsLoading(false);
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: `${
                err?.response?.data["Developer Message"]
                  ? err?.response?.data["Developer Message"]
                  : "Something went wrong!"
              }`,
              showConfirmButton: false,
              timer: 3000,
            });
            setIsLoading(false);
          });
      }
    }
  };

  /*
    const handleKeyPress = async (e) => {
      setIsLoading(true);
      if (e.key === "Enter") {
        console.log("you have clicked enter button");
      }
    };
    */

  useEffect(() => {
    if (otpbutton) {
      setTimeout(() => {
        Setotpbuton(false);
        Setotpinput(false);
      }, 59000);
    }
  }, [otpbutton]);

  useEffect(() => {
    if (otpinput) {
      const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, otpinput]);

  const styles = {
    paperContainer: {
      backgroundImage: `url(${"../../assets/images/Group 27479 (1).png"})`,
    },
  };

  const location = useLocation();

  return (
    // <BasicLayout title="Welcome!" description="Select user type" image={curved6}>
    <>
      <PageLayout>
        <DefaultNavbar
          routes={pageRoutes}
          action={{
            type: "external",
            route: "https://creative-tim.com/product/soft-ui-dashboard-pro-react",
            label: "buy now",
          }}
          transparent
          light
        />

        <div className="vendor_bg">
          {/* {location?.pathname === "/login" ? (
            <img src={img1} alt="" style={{ height: "auto", width: "100%" }} />
          ) : null} */}

          <div className="vendor_flex">
            <Grid container sx={{ maxHeight: "80%", mx: 5 }}>
              {!matchsm ? (
                <Grid item lg={8} md={8} sm={12} xs={12}>
                  {/* <div className="bannernew" /> */}
                  <SoftBox m={2}>
                    <Grid container spacing={2}>
                      <Grid item>
                        <SoftBox
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <img src={img4} alt="Image1" height="170px" width="170px" />
                          <SoftBox>
                            <SoftTypography
                              sx={{ fontSize: "24px", fontWeight: "400", color: "#FFFFFF" }}
                            >
                              Real-Time Session Tracking
                            </SoftTypography>
                            <SoftTypography
                              sx={{ fontSize: "16px", fontWeight: "500", color: "#FFFFFF" }}
                            >
                              Stay informed with real-time updates on all your training sessions.
                              Track attendance, engagement, and progress as they happen.
                            </SoftTypography>
                          </SoftBox>
                        </SoftBox>
                      </Grid>
                      <Grid item>
                        <SoftBox
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <SoftBox>
                            <SoftTypography
                              sx={{ fontSize: "24px", fontWeight: "400", color: "#FFFFFF" }}
                            >
                              Comprehensive Performance Analytics
                            </SoftTypography>
                            <SoftTypography
                              sx={{ fontSize: "16px", fontWeight: "500", color: "#FFFFFF" }}
                            >
                              Access detailed reports on learner progress, session effectiveness,
                              and overall training outcomes to identify strengths and areas for
                              improvement.
                            </SoftTypography>
                          </SoftBox>
                          <img src={img6} alt="Image2" height="170px" width="170px" />
                        </SoftBox>
                      </Grid>
                      <Grid item>
                        <SoftBox
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <img src={img5} alt="Image3" height="170px" width="170px" />
                          <SoftBox>
                            <SoftTypography
                              sx={{ fontSize: "24px", fontWeight: "400", color: "#FFFFFF" }}
                            >
                              User-Friendly Management Tools
                            </SoftTypography>
                            <SoftTypography
                              sx={{ fontSize: "16px", fontWeight: "500", color: "#FFFFFF" }}
                            >
                              Simplify your training management. Schedule sessions and manage
                              resources all from one centralized platform, making your training
                              process more efficient and organized.
                            </SoftTypography>
                          </SoftBox>
                        </SoftBox>
                      </Grid>
                    </Grid>
                  </SoftBox>
                  <div></div>
                </Grid>
              ) : null}

              <Grid item lg={4} md={4} sm={12} xs={12} sx={{ borderRadius: "5px" }}>
                <Box sx={{ height: "100%", background: "#FFFFFF", borderRadius: "20px" }}>
                  <Card
                    sx={
                      matchsm
                        ? { width: "100%", minHeight: "100%", borderRadius: "0px" }
                        : { width: "100%", minHeight: "100%", borderRadius: "10px" }
                    }
                  >
                    <SoftBox
                      px={{ xs: transparent ? 2 : 3, sm: transparent ? 1 : 2, lg: "59px" }}
                      pt="60px"
                      height="100%"
                      minHeight="500px"
                      borderRadius="sm"
                      color={light ? "white" : "dark"}
                      display="flex"
                      flexDirection="column"
                      gap="1em"
                      alignItems="center"
                      sx={({
                        palette: { transparent: transparentColor, white },
                        functions: { rgba },
                      }) => ({
                        backgroundColor: transparent ? "primary" : "#ffff",
                        backdropFilter: transparent ? "none" : `blur(4px)`,
                      })}
                    >
                      {/* <img src={imgA3} height={"55px"} alt="" /> */}

                      <SoftBox
                        borderRadius="sm"
                        sx={{
                          width: "100%",
                          background: "white",
                          minHeight: "450px",
                          maxHeight: "100%",
                        }}
                      >
                        {userRole !== ADMIN ? (
                          <>
                            <SoftBox pt={2} px={1}>
                              <SoftBox mb={2}>
                                {/* <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "24px",
                                    lineHeight: "26px",
                                    fontFamily: "Poppins",
                                    color: "#000000",
                                  }}
                                >
                                  Login
                                </Typography> */}
                                <SoftBox sx={{ display: "flex", justifyContent: "center" }}>
                                  <img src={logo1} height={"70px"} alt="" />
                                </SoftBox>
                                <br />

                                <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "26px",
                                    fontFamily: "Poppins",
                                    color: "#000000",
                                  }}
                                >
                                  Email Address
                                </Typography>
                                <ThemeProvider theme={customTheme(outerTheme)}>
                                  <TextField
                                    id="outlined-size-small"
                                    size="small"
                                    fullWidth
                                    type="email"
                                    placeholder="Email"
                                    value={loginEmail.email}
                                    onChange={(e) => {
                                      setLoginEmail({ ...loginEmail, email: e.target.value });
                                    }}
                                    onKeyPress={(e) => handleKeyPress(e)}
                                  />
                                </ThemeProvider>
                              </SoftBox>
                              <SoftBox mb={4}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "26px",
                                    fontFamily: "Poppins",
                                    color: "#000000",
                                  }}
                                >
                                  Password
                                </Typography>

                                <ThemeProvider theme={customTheme(outerTheme)}>
                                  <TextField
                                    id="outlined-size-small"
                                    size="small"
                                    fullWidth
                                    type={showPassword ? "text" : "password"}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end" sx={{ ml: "auto" }}>
                                          <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword((show) => !show)}
                                            onMouseDown={handleChange}
                                            edge="end"
                                            sx={{ color: "#B3B6B7", ml: "auto" }}
                                          >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder="Password"
                                    value={loginEmail.password}
                                    onChange={(e) => {
                                      setLoginEmail({ ...loginEmail, password: e.target.value });
                                    }}
                                    onKeyPress={(e) => handleKeyPress(e)}
                                  />
                                </ThemeProvider>
                              </SoftBox>
                            </SoftBox>
                          </>
                        ) : (
                          <>
                            <SoftBox pt={2} px={1}>
                              <SoftBox mb={2}>
                                <SoftTypography
                                  variant="h10"
                                  color="black"
                                  fontWeight="350"
                                  fontSize="15px"
                                >
                                  Mobile Number
                                </SoftTypography>
                                <SoftBox display="flex">
                                  <SoftInput
                                    type="text"
                                    placeholder="Mobile Number"
                                    sx={{ mr: 1 }}
                                    onChange={(e) => {
                                      setOTP({ ...OTP, mobileno: e.target.value });
                                    }}
                                  />
                                  {!otpbutton && (
                                    <SoftBox
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        backgroundColor: "#3B5092",
                                        color: "#FFF",
                                        minWidth: "94px",
                                        fontSize: "14px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        // disabled: `${otpbutton}`,
                                      }}
                                      onClick={(e) => sendOtp()}
                                    >
                                      Get OTP
                                    </SoftBox>
                                  )}
                                </SoftBox>
                              </SoftBox>
                            </SoftBox>
                            {otpinput && (
                              <SoftBox mb={4}>
                                <SoftTypography
                                  variant="h10"
                                  color="black"
                                  fontWeight="350"
                                  fontSize="15px"
                                >
                                  OTP Expiry in {counter} Second
                                </SoftTypography>
                                <SoftInput
                                  type="text"
                                  placeholder="OTP"
                                  onChange={(e) => {
                                    setOTP({ ...OTP, otp: e.target.value });
                                  }}
                                />
                              </SoftBox>
                            )}
                          </>
                        )}

                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                          <Box sx={{ width: "200px", textAlign: "right" }}>
                            <Typography
                              variant="body1"
                              sx={{
                                color: "rgba(0, 115, 187, 1)",
                                paddingRight: "16px",
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "26px",
                                fontFamily: "Poppins",
                                "&:hover": {
                                  cursor: "pointer",
                                },
                              }}
                              onClick={() => navigate("/forgotpassword1")}
                            >
                              Forgot Password?
                            </Typography>
                          </Box>
                        </Box>
                        <br />

                        <MuiButton
                          onClick={handleLogin}
                          sx={{
                            width: "100%",
                            height: "51px",
                            background: "rgba(255, 92, 0, 0.7)",
                            borderRadius: "10px",
                            textDecoration: "none",
                            textTransform: "none",
                            color: "#FFFFFF",
                            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.10)",
                            "&:hover": {
                              width: "100%",
                              height: "51px",
                              background: "rgba(255, 92, 0, 0.7)",
                              borderRadius: "10px",
                              textDecoration: "none",
                              textTransform: "none",
                              color: "#FFFFFF",
                              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.10)",
                            },
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              fontSize: "18px",
                              lineHeight: "26px",
                              fontFamily: "Poppins",
                              color: "#FFFFFF",
                            }}
                          >
                            {!isLoading ? "Login" : "Loading"}
                          </Typography>
                        </MuiButton>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default LoginVendor;
